export enum ApplicantInterviewerEvaluations {
    pending = 'pending',
    passed = 'passed',
    failed = 'failed',
}
